import { Input, Avatar, notification } from 'antd'
import React, {useState} from 'react'
import { CommentOutlined } from '@ant-design/icons';
import * as FirestoreService from '../../firebase'
import { useSelector } from 'react-redux'

const AddComments = ({postId, afterUpdate}) => {
    const user = useSelector(state => state.user)
    const [comment, setComment] = useState("");
    const profile = useSelector(state => state.profile)

    const openSuccessNotif = () => {
        notification["success"]({
          message: 'Success',
          description: 'Your comment been added',
          duration: 2
        });
      };

    const openErrorNotif = (msg) => {
        notification["error"]({
        message: 'Error',
        description: msg,
        duration: 3
        });
    };

    const addComment = () => {
        if(comment!= ""){
            let commentData = {};
            commentData.userName = user.username;
            commentData.content = comment;
            if(profile.avatarUrl){
                commentData.userAvatarUrl = profile.avatarUrl
            }else{
                commentData.userAvatarSymbols = profile.firstName.charAt(0) +  profile.lastName.charAt(0)
            }
            FirestoreService.commentPost(postId, commentData)
            openSuccessNotif()
            setComment("");
            afterUpdate();
        }else{
            openErrorNotif("Comment cannot be empty")
        }
    }

    return (
            <Input size="middle" placeholder="Write a comment" 
                name="comment"
                prefix={
                    profile.avatarUrl 
                        ? 
                        <Avatar size="large" src={profile.avatarUrl} />
                        : 
                        <Avatar size="large">
                            {profile.firstName.charAt(0) +  profile.lastName.charAt(0)}
                        </Avatar>
                } 
                bordered={false}
                style={{width:"100%", marginTop:5}}
                addonAfter={
                        <CommentOutlined className="bla"
                            style={{ border:0, background:"none", fontSize:18}} 
                            onClick={addComment}
                        />
                }
                value={comment}
                onChange={event => setComment(event.target.value)}
                onPressEnter={addComment}               
            />
    )
}

export default AddComments
